import CustomerContactCollection from "@/collections/crm/CustomerContactCollection";
import CrmServiceModel from "@/models/CrmServiceModel";
import CustomerModel from "@/models/crm/CustomerModel";

export default class CustomerLocationModel extends CrmServiceModel {
  modelName() {
    return 'customer-locations';
  }
  icon() {
    return 'map-marked';
  }
  defaults() {
    return {
      id: null,
      customer_id: null,
      customer: null,
      street_address: null,
      city: null,
      region: null,
      country: null,
      postal_code: null,
      type: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      customer_contacts: [],
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      customer_id: (val) => (this.nullStringMutator(val)),
      street_address: (val) => (this.nullStringMutator(val)),
      city: (val) => (this.nullStringMutator(val)),
      region: (val) => (this.nullStringMutator(val)),
      country: (val) => (this.nullStringMutator(val)),
      postal_code: (val) => (this.nullStringMutator(val)),
      type: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }
  validation() {
    return {}
  }
  getCustomerContacts() {
    return this.getRelatedCollection(new CustomerContactCollection(), 'customer_contacts');
  }
  getCustomer() {
    return this.getRelatedModel(CustomerModel, 'customer');
  }
  fullAddress() {
    return [
      this.street_address,
      this.city,
      this.region,
      this.country,
      this.postal_code,
    ].filter(x => x).join(', ');
  }
  shortAddress() {
    return [
      this.city,
      this.country,
    ].filter(x => x).join(', ');
  }
}
